import * as React from 'react';

import './button.style.css';
import EllipsisText from './ellipsisText';

export interface TButtonProps {
  /** Html button element name */
  name: string;
  /** Button display text */
  text: string;
  /** Css class name to apply on the button */
  className?: string;
  /** Button click event handler */
  onClick?: (event: any) => void;
  /** button disabled flag */
  disabled?: boolean;
  /** flag to set ellipsis or not */
  ellipsis?: boolean;
  /** Max text length beyond which ellipsis will be displayed */
  ellipsisLength?: number;
}

export const Button: React.StatelessComponent<TButtonProps> = ({
  name,
  text,
  className,
  onClick,
  disabled,
  ellipsis,
  ellipsisLength,
}) => {
  if (className) {
    className += ' button';
  } else {
    className = 'button';
  }

  if (disabled === true) {
    className += ' disabled';
  }
  return (
    <button
      className={className}
      name={name}
      onClick={onClick}
      disabled={disabled}
    >
      {ellipsis ? <EllipsisText text={text} length={ellipsisLength} /> : text}
    </button>
  );
};

Button.defaultProps = {
  className: '',
  disabled: false,
  ellipsis: false,
  ellipsisLength: 0,
  name: 'buttonelement1',
  text: '',
};
